import { useState, useEffect } from "react";

export default function useOutsideClicks(
  targetRef,
  handleOutsideClick,
  containerRef
) {
  const [listening, setListening] = useState(false);

  useEffect(() => {
    if (!handleOutsideClick || !targetRef.current || listening) {
      return;
    }

    setListening(true);
    const listenerTarget = containerRef.current ? containerRef.current : document;

    [`click`, `touchstart`].forEach(type => {
      listenerTarget.addEventListener(`click`, evt => {
        const current = targetRef.current;
        const node = evt.target;
        if (!current.contains(node)) {
          handleOutsideClick?.();
        }
      });
    });
  });
}
